module.exports = __webpack_public_path__ + "media/components/country-flag/static/an-d6400b9c1ec997ff152e8d629d424c7e.svg";